<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <el-form ref="formRef" :model="form" label-width="auto" style="margin: auto;max-width: 80%;" size="small"
            :rules="rules">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="商户CODE" prop="code">
                        <el-input v-model="form.code" />
                    </el-form-item>
                    <el-form-item label="企业名称" prop="partner_name">
                        <el-input v-model="form.partner_name" />
                    </el-form-item>
                    <el-form-item label="联系人姓名" prop="contact_name">
                        <el-input v-model="form.contact_name" />
                    </el-form-item>
                    <el-form-item label="联系人电话" prop="mobile">
                        <el-input v-model="form.mobile" />
                    </el-form-item>
                    <el-form-item label="联系人邮箱" prop="email">
                        <el-input v-model="form.email" />
                    </el-form-item>
                    <el-form-item label="结算币种" prop="currency">
                        <el-select v-model="form.currency" placeholder="请选择结算币种">
                            <el-option v-for="item in currencyOptionList" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button type="primary" size="small" @click="onSubmit(formRef)">确定</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { reactive, onMounted, ref, toRaw } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../../axios/api'
import { currencyOptions } from '../../../util/salesPartner'

export default {
    setup() {
        const router = useRouter()
        const route = useRoute()
        // 币种下拉选项统一取自共享字典，新增币种只需改 util
        const currencyOptionList = currencyOptions()
        const form = reactive({
            code: '',
            partner_name: '',
            contact_name: '',
            mobile: '',
            email: '',
            currency: 'CNY'
        })
        const formRef = ref()
        const rules = reactive({
            code: [
                { required: true, message: '请输入商户CODE', trigger: 'blur' },
            ],
            partner_name: [
                { required: true, message: '请输入企业名称', trigger: 'blur' },
            ],
            contact_name: [
                { required: true, message: '请输入联系人姓名', trigger: 'blur' },
            ],
            mobile: [
                { required: true, message: '请输入联系人电话', trigger: 'blur' },
            ]
        })
        const isEdit = ref(false)
        // 进入编辑时的原结算币种，用于 1007（已有余额不能修改结算币种）时回滚下拉
        const originCurrency = ref('CNY')

        console.log('route -->', route)


        const onSubmit = async (formEl) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    const apiMethod = isEdit.value ? api.SalesPartnerUpdate : api.SalesPartnerCreate
                    const res = await apiMethod(toRaw(form))
                    if (res.data.code === 200) {
                        ElMessage.success(`${isEdit.value ? '更新' : '添加'}成功`)
                        router.push('/salespartner/list')
                    } else {
                        // 1007：商户已有余额，后端不允许修改结算币种，把下拉还原为原值避免误导
                        if (res.data.code === 1007) {
                            form.currency = originCurrency.value
                        }
                        ElMessage.error(res.data.msg)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        const goback = () => {
            router.go(-1)
        }

        onMounted(() => {
            const code = route.params.code
            if (code && code !== '0') {
                isEdit.value = true
                api.SalesPartnerDetail({ code }).then(res => {
                    if (res.data.code === 200) {
                        Object.assign(form, res.data.data)
                        // 记录原币种，保存遇 1007 时据此回滚
                        originCurrency.value = form.currency
                    } else {
                        ElMessage.error('获取详情失败: ' + res.data.msg)
                    }
                }).catch(err => {
                    console.error('获取详情失败:', err)
                    ElMessage.error('获取详情失败')
                })
            }
        })

        return {
            form,
            onSubmit,
            goback,
            rules,
            formRef,
            isEdit,
            currencyOptionList
        }
    }
}
</script>